export default [
  {
    motive: 'welding.smoke.welding.smoke',
    subphase: 'process',
  },
  {
    motive: 'combustion.gases.vehicles.boilers.generator.set.etc',
    subphase: 'process.transport',
  },
  {
    motive: 'adhesive.glue.emission.insulation',
    subphase: 'purchase.process',
  },
  {
    motive: 'fibers.emission.fibers.when.cutting',
    subphase: 'process',
  },
  {
    motive: 'other.particles.vehicle.traffic.trenches.etc',
    subphase: 'process.transport',
  },
  {
    motive: 'noise.vehicles.use.grinder.drills.etc',
    subphase: 'process.transport',
  },
  {
    motive: 'vibrations.drills.engines.etc',
    subphase: 'process.transport',
  },
  {
    motive: 'sanitary.water.toilets.dining.room.etc',
    subphase: 'process',
  },
  {
    motive: 'residuals.start.up.purges.water.discharges.repairs.etc',
    subphase: 'process',
  },
  {
    motive: 'pluvial.rain.in.construction',
    subphase: 'process',
  },
  {
    motive: 'fuel.diesel.consumption.vehicle.fleets.boiler.usage',
    subphase: 'purchase.process.transport',
  },
  {
    motive: 'electricity.equipment.usage.office.electricity.construction',
    subphase: 'purchase.process',
  },
  {
    motive: 'water.sanitary.cleaning.leak.testing',
    subphase: 'process',
  },
  {
    motive: 'technical.gases.vacuum.production',
    subphase: 'purchase.process',
  },
  {
    motive: 'natural.gas.usage.boiler',
    subphase: 'purchase.process',
  },
  {
    motive: 'paper.cardboard.packaging.of.products.equipment',
    subphase: 'purchase.process',
  },
  {
    motive: 'plastics.originating.packaging.products.equipment.pvc.scraps.etc',
    subphase: 'purchase.process',
  },
  {
    motive: 'wood.presence.packaging.etc',
    subphase: 'purchase.process',
  },
  {
    motive: 'metal.scraps.presence.scrap',
    subphase: 'purchase.process',
  },
  {
    motive: 'cable.peelings.works.with.cables',
    subphase: 'process',
  },
  {
    motive: 'waste.mix.general.waste',
    subphase: 'purchase.process',
  },
  {
    motive: 'electrical.material.equipment.material.remains',
    subphase: 'purchase.process',
  },
  {
    motive: 'insulating.material.scraps.metal.enclosures.with.rock.wool',
    subphase: 'purchase.process',
  },
  {
    motive: 'boiler.ashes.chimney.ashes.slags.boiler.dust.non.hydrocarbons',
    subphase: 'process',
  },
  {
    motive: 'debris.foundations.trenches',
    subphase: 'process',
  },
  {
    motive: 'water.with.cement.foundations',
    subphase: 'process',
  },
  {
    motive: 'boiler.ashes.hydrocarbons.fly.ash.boiler.dust',
    subphase: 'process',
  },
  {
    motive: 'lubricant.oils.coolant.oil.residues.tube.cutting',
    subphase: 'purchase.process',
  },
  {
    motive: 'absorbents.rags.equipment.cleaning',
    subphase: 'process',
  },
  {
    motive: 'contaminated.containers.glue.paint.etc',
    subphase: 'purchase.process',
  },
  {
    motive: 'creosote.materials.with.creosote.posts',
    subphase: 'purchase.process',
  },
  {
    motive: 'glycol.antifreeze.solar.heating.system',
    subphase: 'purchase.process',
  },
  {
    motive: 'refrigerant.gases.maintenance',
    subphase: 'purchase.process',
  },
  {
    motive: 'biocides.shock.treatments.used.towers.equipment.legionella.risk',
    subphase: 'purchase.process',
  },
  {
    motive: 'landscape.alteration.material.stockpiling.trench.opening.etc',
    subphase: 'purchase.process',
  },
  {
    motive: 'traffic.impact.material.stockpiling.traffic.flow.etc',
    subphase: 'purchase.process.transport',
  },
  {
    motive: 'order.cleanliness.general.site.cleanup',
    subphase: 'purchase.process',
  },
  {
    motive: 'dielectric.oils',
    subphase: 'purchase.process',
  },
  {
    motive: 'rechargeable.batteries',
    subphase: 'purchase.process',
  },
];
